// src/services/ttn/deviceLocations.js
// ─────────────────────────────────────────────────────────────────────────────
// Static fallback location strings for each device.
// Source of truth: TTN console + GPS coordinates (verified 2026-03-11)
//
// HOW TO UPDATE:
//   Preferred way → use the "Station Names" tab in the SuperAdmin dashboard.
//   That saves to the database and takes priority over this file.
//
//   To update the static fallback:
//   Add/edit a line:  '<device_id>': '<Area, County, Kenya>',
// ─────────────────────────────────────────────────────────────────────────────

const DEVICE_LOCATIONS = {
  // ── Western Kenya — Busia County ─────────────────────────────────────────────
  '101990961244800001': 'Butunyi, Busia County, Kenya',
  '101990961244800061': 'Butula, Busia County, Kenya',
  '101990961244800083': 'Lugulu, Busia County, Kenya',
  '101990961244800101': 'Bumutiru, Busia County, Kenya',
  '101990961244800102': 'Bwaliro, Busia County, Kenya',
  '101990961244800113': 'Bukhalarire, Busia County, Kenya',
  '101990961244800131': 'Bumala, Busia County, Kenya',
  '101990961244800184': 'Butula, Busia County, Kenya',
  '101990961244800201': 'Nambale, Busia County, Kenya',
  '101990961244800207': 'Sibembe, Busia County, Kenya',
  '101990961244800222': 'Khayo, Busia County, Kenya',
  '101990961244800246': 'Mabunge, Busia County, Kenya',
  '101990961244800270': 'Emukhuyu, Busia County, Kenya',
  '101990961244800281': 'Busiada, Busia County, Kenya',
  '101990961244800302': 'Elwanikha, Busia County, Kenya',
  '101990961244800306': 'Sikoma, Busia County, Kenya',
  '101990961244800317': 'Madende, Busia County, Kenya',
  '101990961244800336': "Mung'abo, Busia County, Kenya",
  '101990961244800342': 'Tingolo, Busia County, Kenya',
  '101990961244800348': 'Nambale, Busia County, Kenya',
  '101990961244800361': 'Bukhuma, Busia County, Kenya',
  '101990961244800375': 'Igara, Busia County, Kenya',
  '101990961244800389': 'Malanga, Busia County, Kenya',
  '101990961244800393': 'Namaindi, Busia County, Kenya',
  '101990961244800395': 'Musokoto, Busia County, Kenya',
  '101990961244800005': 'Sikanga, Bungoma County, Kenya',

  // ── Other regions ─────────────────────────────────────────────────────────────
  '101990961244800212': 'Lukenya, Machakos County, Kenya',
  '202003536241300473': 'Marsabit County, Kenya',

  // ── Add future devices below ─────────────────────────────────────────────────
  // '<device_id>': '<Area, County, Kenya>',
};

export default DEVICE_LOCATIONS;
